import { render, staticRenderFns } from "./ChefiaValidacaoFerias.vue?vue&type=template&id=4ba2e438&"
import script from "./ChefiaValidacaoFerias.vue?vue&type=script&lang=js&"
export * from "./ChefiaValidacaoFerias.vue?vue&type=script&lang=js&"
import style0 from "./ChefiaValidacaoFerias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports